export const PORT_EXPANDER_RNUMBER = 'R35827' as const
export const PORTS_LIMIT = 4 as const

export const ITEMS_NA = ['7', '17']
export const ITEMS_PRESELECTED = ['11', '15', '31', '32', '33', '49', '51', '34', '1', '21', '52']

export const SENSOR_CATEGORY = '2' as const
export const POWER_CATEGORY = '4' as const

export const PX_PER_CHARACTER = 5 as const
export const CONTROL_POWER = 'R35817' as const
export const CONTROL_POWER_DELUXE = 'R35818' as const

export const CONTROL_HUB_IDS = ['1', '3']
export const PRO_HUBS_IDS = ['3', '4']
export const DELUXE_HUBS_IDS = ['4']
export const DELUXE_SINGLE_PROBE_HOLDER = '52' as const
